import { capitalCase } from "change-case";
import moment from "moment";
import ParseDate from "src/components/parse-date";
import swiftParseDate from "src/utils/swift-parse-date";

const forSIP = (data, line) => {
  const temp = {};
  temp.Line = line;
  temp["Date"] = swiftParseDate(data?.created_at);
  temp["SIP Amount"] = data?.sip_amount || "";
  temp["Account ID"] = data?.user?.username;
  temp["Referrer"] = data?.sponsor;
  temp["Years"] = capitalCase(data?.years);
  temp["Potential Fund"] = data?.potential_fund;
  temp["Net Fund"] = data?.total_amount;
  temp["Status"] = data?.status;
  return temp;
};

export default forSIP;
